function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Provides functionality to draw MyPlaces layers on the map
 *
 * @class Oskari.mapframework.bundle.mapmyplaces.plugin.MyPlacesLayerPlugin
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmyplaces.plugin.MyPlacesLayerPlugin',
/**
 * @static @method create called automatically on construction
 *
 *
 */
function (config) {
  this._config = config;
}, {
  _clazz: 'Oskari.mapframework.bundle.mapmyplaces.plugin.MyPlacesLayerPlugin',
  __name: 'MyPlacesLayerPlugin',
  /** @static @property layertype type of layers this plugin handles */
  layertype: 'myplaces',
  getLayerTypeSelector: function getLayerTypeSelector() {
    // WFS plugin handles events
  },
  /**
   * Interface method for the module protocol.
   * @private @method _initImpl
   */
  _initImpl: function _initImpl() {
    var _this$getSandbox$getS;
    var type = this.layertype;
    var options = _objectSpread({
      type: type,
      editRequest: 'MyPlaces.EditCategoryRequest'
    }, Oskari.getMsg('MapMyPlaces', 'layer'));
    (_this$getSandbox$getS = this.getSandbox().getService('Oskari.mapframework.service.MapLayerService')) === null || _this$getSandbox$getS === void 0 || _this$getSandbox$getS.registerLayerForUserDataModelBuilder(options);

    // Let wfs plugin handle this layertype
    var wfsPlugin = this.getMapModule().getLayerPlugins('wfs');
    wfsPlugin.registerLayerType(type, 'Oskari.mapframework.bundle.mapmyplaces.domain.MyPlacesLayer');
    this.unregister();
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.AbstractMapLayerPlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});